export default __webpack_public_path__ + "static/media/theme_ilm.a252a272.jpg";